import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';

export const getShiftWorkbenchSubStuff = (where: string) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() +
      `shift-workbench/workbench-sub-stuff?where=` +
      where
  );
};
export const AddShiftWorkbenchSubStuff = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() +
      `shift-workbench/workbench-sub-stuff/create`,
    obj,
    { headers }
  );
};

export const EditShiftWorkbenchSubStuff = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() +
      `shift-workbench/workbench-sub-stuff/edit`,
    obj,
    { headers }
  );
};

export const DeleteShiftWorkbenchSubStuff = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() +
      `shift-workbench/workbench-sub-stuff/delete`,
    obj,
    { headers }
  );
};
